import { writeText } from 'clipboard-polyfill';

import { IS_PRODUCTION } from 'constants/envs';
import { logger } from 'utils/logger';

// Resolves to whether the write succeeded, so a caller that renders a "Copied" confirmation only
// shows it on a real success; fire-and-forget callers can keep ignoring the result.
export const copyToClipboard = text =>
  writeText(text)
    .then(() => true)
    .catch(err => {
      if (!IS_PRODUCTION) {
        logger.error(`Could not copy text - ${err}`);
      }

      return false;
    });
